module.exports = __webpack_public_path__ + "img/flexben-logo.7d3c1b07.svg";